/**
 * Created by portiz on 8/24/2018.
 */
class Settings {

    // Web Service PRODUCTION URL
    static PRODUCTION_URL = "https://www.genialskillsservice.com:8981";
    static DEVELOPMENT_URL = "https://www.genialskillsservice.com:8385";
    static STRIPE_PRODUCTION_TOKEN_KEY = "pk_live_4EWWLeafJxVpc4ftuhpt7WwP";
    static STRIPE_DEVELOPMENT_TOKEN_KEY = "pk_test_nAq1KhiYjAcXNpTO8cDB0jmW";
    static PRODUCTION_ATHENAS_URL = "https://www.genialskillsservice.com:8738";
    static DEVELOPMENT_ATHENAS_URL = "http://74.208.103.1:8882";

    static webServiceURL = "http://74.208.167.1:7776"; //; "https://www.genialskillsservice.com:8981"; //"http://74.208.103.1:8777";
    static athenasWebServiceURL =  "http://74.208.167.1:7777";//https://www.genialskillsservice.com:8738"; // "http://74.208.103.1:8882";
    static stripeTokenClient = "pk_live_4EWWLeafJxVpc4ftuhpt7WwP"; //"pk_test_nAq1KhiYjAcXNpTO8cDB0jmW";
    static DEFAULT_LANGUAGE = 'es';

    static CLIENT_ROLE_ID = '1';
    static CLIENT_CHILD_ROLE_ID = '3';

    static CHAT_LIVE_CHAT_LICENSE = 10895502;

    /**
     * The API to get the profile activity
     */
    static getProfilesActivityAPI(){
        return this.webServiceURL + '/api/ProfilesActivity';
    }

    /**
     * The API to get the report usage
     * @returns {string}
     */
    static getReportUsageAPI(){
        return this.webServiceURL + '/api/ReportUsage';
    }

    /**
     * The API to get the report subscriptiosn
     * @returns {string}
     */
    static getReportSubscriptionsAPI(){
        return this.webServiceURL + '/api/ReportSubscriptions'
    }

    /**
     * Get the roles to read api
     * @returns {string}
     */
    static getRolesReadAPI(){
        return this.webServiceURL + '/api/RolesRead';
    }

    /**
     * Get the status account read
     * @returns {string}
     */
    static getStatusAccountReadAPI(){
        return this.webServiceURL + '/api/StatusAccountRead';
    }

    /**
     * The url to validate coupon
     * @returns {string}
     */
    static getCouponValidateAPI(){
        return this.webServiceURL + '/api/CouponValidate';
    }

    /**
     * The url where the coupon is created
     * @returns {string}
     */
    static getCouponCreateAPI(){
        return this.webServiceURL + '/api/CouponCreate';
    }

    /**
     * The url where the coupon is read
     * @returns {string}
     */
    static getCouponsReadAPI(){
        return this.webServiceURL + '/api/CouponsRead';
    }

    /**
     * The url where the windows app is
     */
    static getDownloadWindowsAppURL(){
        return 'https://www.genialskillsservice.com:8981/assets/GenialSkillsWebSetup.exe';
    }

    /**
     * The url where the mac app is
     */
    static getDownloadMacAppURL(){
        return 'https://www.genialskillsservice.com:8981/assets/GenialSkillsWebMac.zip';
    }

    /**
     * THe url where the android app is
     */
    static getDownloadAndroidAppURL(){
        return 'https://play.google.com/store/apps/details?id=com.RequireTechnology.GenialSkillsWeb';
    }

    /**
     * The url where the ipad app is
     */
    static getDownloadIpadsAppUrl(){
        return 'https://apps.apple.com/us/app/genial-skills-web-ipad-ver/id1460609057';
    }

    /**
     * Returns the stripe token
     * @returns {string}
     */
    static getStripeToken(){
        return this.stripeTokenClient;
    }

    static getUsersAdvanceRead(){
        return this.webServiceURL + '/api/UsersAdvanceRead';
    }

    static getUploadUsersBulk(){
        return this.webServiceURL + '/api/UploadUsersBulk';
    }

    static getRegisterOnePageAPI(){
        return this.webServiceURL + '/api/RegisterSubscribe';
    }

    static getSubscriptionReadAPI(){
        return this.webServiceURL + '/api/SubscriptionAdvanceRead';
    }

    static getPlansAdvaceReadAPI(){
        return this.webServiceURL + '/api/PlansAdvanceRead';
    }

    static getCancellationAPI(){
        return this.webServiceURL + '/api/SubscriptionCancellation'
    }

    static getPlanCreateAPI(){
        return this.webServiceURL + '/api/PlanCreate';
    }

    static getPlanUpdateAPI(){
        return this.webServiceURL + '/api/PlanUpdate';
    }

    static getCountriesFullDetailsAPI(){
        return this.webServiceURL + '/api/CountryFullDetails';
    }

    static getLanguagesAPI(){
        return this.webServiceURL + '/api/LanguageRead';
    }

    static getTaxesAPI(){
        return this.webServiceURL + '/api/TaxesRead';
    }

    static getProductsAPI(){
        return this.webServiceURL + '/api/ProductRead';
    }

    static getBillingIntervalAPI(){
        return this.webServiceURL + '/api/BillingIntervalRead';
    }

    static getCurrenciesAPI(){
        return this.webServiceURL + '/api/CurrencyReadAvailable';
    }

    static getChatToggleAPI(){
        return this.webServiceURL + '/api/ChatToggle';
    }

    static getChatStatusAPI(){
        return this.webServiceURL + '/api/ChatStatusRead';
    }

    static getUserFullNameAPI(){
        return this.webServiceURL + '/api/EmployeeNameRead';
    }

    static getMiniGamesLockCreateAPI(){
        return this.webServiceURL + '/api/MiniGameLockCreate';
    }

    static getMiniGamesBlockReaderAPI(){
        return this.webServiceURL + '/api/MiniGamesBlockReader';
    }

    static getItemsSubscribedUsersAPI(){
        return this.webServiceURL + '/api/ItemsMainAccount';
    }

    static getPlanDetailsAPI(){
        return this.webServiceURL + '/api/PlanDetailsRead';
    }

    static getPlansAvailableAPI(){
        return this.webServiceURL + '/api/PlansRead';
    }

    static getPlanCostAPI(){
        return this.webServiceURL + '/api/PlanCalculateCosts';
    }

    static getSubscribeUserToPlanByEmployeeAPI(){
        return this.webServiceURL + '/api/SubscribeUserByEmployee';
    }

    static getSubscribeUserToPlanAPI(){
        return this.webServiceURL + '/api/SubscribeUserToPlan';
    }

    static getAssignSeatAPI(){
        return this.webServiceURL + '/api/AssignSeat';
    }

    static getUpdatePaymentMethodAPI(){
        return this.webServiceURL + '/api/PaymentMethodUpdate';
    }

    static getUserNewPasswordInsertAPI(){
        return this.webServiceURL + '/api/PasswordUpdateByUser';
    }

    static getUserMainAddressAPI(){
        return this.webServiceURL + '/api/MainAccountAddressRead';
    }

    static getUserMainAddressUpdateAPI(){
        return this.webServiceURL + '/api/MainAccountAddressUpdate';
    }

    static getRegisterProfileAPI(){
        return this.webServiceURL + '/api/RegisterProfile';
    }

    static getUserRegisterByAdminAPI(){
        return this.webServiceURL + '/api/UserRegister';
    }

    static getUserInfoUpdateByAdminAPI(){
        return this.webServiceURL + '/api/UserInfoUpdate'
    }

    static getProductLessonsAPI(){
        return this.webServiceURL + '/api/LessonsRead';
    }

    static getSyllabusReadAPI(){
        return this.webServiceURL + '/api/SyllabusRead';
    }

    static getUserQuizDetailsAPI(){
        return this.webServiceURL + '/api/ProfileQuizResultDetailsRead';
    }

    static getLessonExamsAPI(){
        return this.athenasWebServiceURL + '/api/LessonExamsRead';
    }

    static getUserQuizzesTriesAPI(){
        return this.webServiceURL + '/api/ProfileQuizTriesRead';
    }

    static getProfileUpdatePasswordAPI(){
        return this.webServiceURL + '/api/ProfilePasswordReset';
    }

    static getPasswordResetNewPasswordAPI(){
        return this.webServiceURL + '/api/PasswordResetSubmit'
    }

    static getPasswordResetPetitionAPI(){
        return this.webServiceURL + '/api/PasswordResetPetition';
    }

    static getProfileUpdateInformationAPI(){
        return this.webServiceURL + '/api/ProfileUpdateInformation';
    }

    static getProfileInformationReadAPI(){
        return this.webServiceURL + '/api/ProfileInformationRead';
    }

    static getProfilesAPI(){
        return this.webServiceURL + '/api/ProfilesRead';
    }

    static getProfileProductsAPI(){
        return this.webServiceURL + '/api/ProfileItemsRead';
    }

    static getUserSubscriptionsAPI(){
        return this.webServiceURL + '/api/SubscriptionsClientRead';
    }

    static getStudentAverageAPI(){
        return this.webServiceURL + '/api/ProfileAverageByLessons';
    }

    static getStudentLessonAverageApi(){
        return this.webServiceURL + '/api/ProfileLessonAverageByLessonIdRead';
    }

     static getUsernameAvailabilityAPI(){
         return this.webServiceURL + '/api/UsernameCheckAvailability';
     }

     static getEmailAvailabilityAPI(){
         return this.webServiceURL + '/api/EmailCheckAvailability';
     }

     static getLoginAPI(){
         return this.webServiceURL + '/api/LoginMainAccount';
     }

    static getLoginEmployeeAPI(){
        return this.webServiceURL + '/api/LoginEmployee';
    }

     static getCountriesAPI(){
         return this.webServiceURL + '/api/CountryReadAvailable';
     }

     static getStateProvincesAPI(){
         return this.webServiceURL + '/api/StatesProvidencesRead';
     }
}

export default Settings;